import { io } from 'socket.io-client';

const socket = io(window.location.origin, {
  path: '/socket.io',
  transports: ['websocket', 'polling'],
  reconnectionAttempts: Infinity,
  reconnectionDelay: 1000,
});

export default socket;
